var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnboardingMachineCompleted = function SvgOnboardingMachineCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 316,
    height: 96,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 364,
    height: 144,
    x: -24,
    y: -24
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12px)",
      clipPath: "url(#onboarding-machine-completed_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#142D33",
    d: "M0 8a8 8 0 0 1 8-8h300a8 8 0 0 1 8 8v80a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 20.25,
    x: 19,
    y: 56.25,
    fill: "#152125",
    stroke: "url(#onboarding-machine-completed_svg__b)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.75,
    height: 3,
    x: 28,
    y: 76.5,
    fill: "#131B20",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 2.25,
    x: 28.375,
    y: 76.875,
    stroke: "url(#onboarding-machine-completed_svg__c)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 1.125
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 5.25,
    x: 71.5,
    y: 54.75,
    fill: "#131B20",
    rx: 2.625,
    transform: "rotate(-90 71.5 54.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.75,
    height: 4.5,
    x: 71.875,
    y: 54.375,
    stroke: "url(#onboarding-machine-completed_svg__d)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 2.25,
    transform: "rotate(-90 71.875 54.375)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 5.25,
    x: 28,
    y: 54.75,
    fill: "#131B20",
    rx: 2.625,
    transform: "rotate(-90 28 54.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.75,
    height: 4.5,
    x: 28.375,
    y: 54.375,
    stroke: "url(#onboarding-machine-completed_svg__e)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 2.25,
    transform: "rotate(-90 28.375 54.375)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 26.5,
    y: 68.25,
    fill: "#3AACC8",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 31,
    y: 68.25,
    fill: "#3AACC8",
    fillOpacity: 0.15,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 35.5,
    y: 68.25,
    fill: "#3AACC8",
    fillOpacity: 0.15,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 40,
    y: 68.25,
    fill: "#3AACC8",
    fillOpacity: 0.15,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#19AF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.359,
    d: "M66.712 23.773c-8.58-6.697-20.844-6.697-29.424 0m6.132 8.568c5.005-3.904 12.157-3.904 17.162 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#19AF00",
    stroke: "#19AF00",
    strokeLinecap: "square",
    strokeWidth: 2.179,
    d: "M52 39.796a1.43 1.43 0 1 1 0 2.86 1.43 1.43 0 0 1 0-2.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 10.5,
    x: 125,
    y: 68.25,
    fill: "#152125",
    stroke: "url(#onboarding-machine-completed_svg__f)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.5,
    height: 5.25,
    x: 181.25,
    y: 75,
    fill: "#131B20",
    rx: 2.625,
    transform: "rotate(-90 181.25 75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.75,
    height: 4.5,
    x: 181.625,
    y: 74.625,
    stroke: "url(#onboarding-machine-completed_svg__g)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 2.25,
    transform: "rotate(-90 181.625 74.625)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.5,
    height: 5.25,
    x: 130.25,
    y: 75,
    fill: "#131B20",
    rx: 2.625,
    transform: "rotate(-90 130.25 75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.75,
    height: 4.5,
    x: 130.625,
    y: 74.625,
    stroke: "url(#onboarding-machine-completed_svg__h)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 2.25,
    transform: "rotate(-90 130.625 74.625)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 45.75,
    x: 135.5,
    y: 60,
    fill: "#131B20",
    rx: 3,
    transform: "rotate(-90 135.5 60)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.75,
    height: 45,
    x: 135.875,
    y: 59.625,
    stroke: "url(#onboarding-machine-completed_svg__i)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 2.625,
    transform: "rotate(-90 135.875 59.625)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.75,
    height: 3,
    x: 132.5,
    y: 46.5,
    fill: "#19AF00",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 10.5,
    x: 125,
    y: 29.25,
    fill: "#152125",
    stroke: "url(#onboarding-machine-completed_svg__j)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 128.75,
    y: 33,
    fill: "#3AACC8",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 133.25,
    y: 33,
    fill: "#3AACC8",
    fillOpacity: 0.15,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 7.5,
    x: 125,
    y: 55.5,
    fill: "#152125",
    stroke: "url(#onboarding-machine-completed_svg__k)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#697477",
    d: "M146.75 20.25a3 3 0 0 1 3-3h15.75a3 3 0 0 1 3 3v12.221a6 6 0 0 1-1.873 4.356l-6.634 6.284a3 3 0 0 1-4.05.07l-7.168-6.338a6 6 0 0 1-2.025-4.495z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 48,
    x: 229.5,
    y: 22.5,
    fill: "#152125",
    stroke: "url(#onboarding-machine-completed_svg__l)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.5,
    height: 25.5,
    x: 243.75,
    y: 33.75,
    fill: "#131B20",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.75,
    height: 24.75,
    x: 244.125,
    y: 34.125,
    stroke: "url(#onboarding-machine-completed_svg__m)",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 2.625
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 8.25,
    x: 247.875,
    y: 37.125,
    stroke: "#697477",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 1.125
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 8.25,
    x: 247.875,
    y: 47.625,
    stroke: "#697477",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 1.125
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 8.25,
    x: 263.625,
    y: 37.125,
    stroke: "#697477",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 1.125
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 8.25,
    x: 263.625,
    y: 47.625,
    stroke: "#697477",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    rx: 1.125
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 233.25,
    y: 62.25,
    fill: "#3AACC8",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 233.25,
    y: 26.25,
    fill: "#697477",
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 238.5,
    y: 26.25,
    fill: "#697477",
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 243.75,
    y: 26.25,
    fill: "#697477",
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 287.25,
    y: 26.25,
    fill: "#3AACC8",
    fillOpacity: 0.4,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 239.25,
    y: 62.25,
    fill: "#3AACC8",
    fillOpacity: 0.15,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 245.25,
    y: 62.25,
    fill: "#3AACC8",
    fillOpacity: 0.15,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 251.25,
    y: 62.25,
    fill: "#3AACC8",
    fillOpacity: 0.15,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 4.5,
    x: 281.25,
    y: 62.25,
    fill: "#697477",
    fillOpacity: 0.4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 4.5,
    x: 269.25,
    y: 62.25,
    fill: "#697477",
    fillOpacity: 0.4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#19AF00",
    d: "M285.417 60.604a.75.75 0 0 1 .937-.937l11.482 3.532a.75.75 0 0 1 .115 1.388l-4.852 2.426a.75.75 0 0 0-.336.336l-2.426 4.852c-.302.605-1.189.532-1.388-.115z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__b",
    x1: 52,
    x2: 52,
    y1: 56.25,
    y2: 76.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__c",
    x1: 52.375,
    x2: 52.375,
    y1: 76.5,
    y2: 79.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__d",
    x1: 92.125,
    x2: 73.75,
    y1: 57.488,
    y2: 57.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__e",
    x1: 48.625,
    x2: 30.25,
    y1: 57.488,
    y2: 57.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__f",
    x1: 158,
    x2: 158,
    y1: 68.25,
    y2: 78.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__g",
    x1: 218.375,
    x2: 185.3,
    y1: 77.738,
    y2: 77.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__h",
    x1: 167.375,
    x2: 134.3,
    y1: 77.738,
    y2: 77.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__i",
    x1: 158.875,
    x2: 138.05,
    y1: 83.859,
    y2: 83.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__j",
    x1: 158,
    x2: 158,
    y1: 29.25,
    y2: 39.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__k",
    x1: 158,
    x2: 158,
    y1: 55.5,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__l",
    x1: 262.5,
    x2: 262.5,
    y1: 22.5,
    y2: 70.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding-machine-completed_svg__m",
    x1: 262.5,
    x2: 262.5,
    y1: 33.75,
    y2: 59.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F1F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "onboarding-machine-completed_svg__a",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 0 1 8-8h300a8 8 0 0 1 8 8v80a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  })))));
};
export { SvgOnboardingMachineCompleted as ReactComponent };
export default __webpack_public_path__ + "c7bb69aa4c7719e93fe451e2af38a85b.svg";